/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.WoodenLivesFeastWindow, {
    person: {
        role: "elf"
    }
});
